import axios from "axios";

export const API = (url, method, data, token) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `https://taxi-backend-qld8.onrender.com/api/v1/admin/${url}`,
      method: method,
      data: data,
      headers: token
        ? {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        : {
            "Accept": "application/json",
            "Content-Type": "application/json",
          },
    })
      .then((res) => {
        // console.log("res: ", res);
        return resolve(res.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
};
